module.exports = __webpack_public_path__ + "img/calendar3.35b1ae41.svg";